import WebApp from './WebApp.jsx';

/**
 * Registry renderer untuk content app.
 * Tambah app baru: buat komponen di folder ini lalu daftarkan di map ini.
 */
export const APP_RENDERERS = {
  web: WebApp,
};

export function getAppRenderer(kindId) {
  const k = String(kindId || '').toLowerCase() || 'web';
  return APP_RENDERERS[k] || WebApp;
}
